import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 120px);
  position: relative;
`

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
`

export const RedemptionCard = styled.div`
  background-color: var(--neutral-theme);
  border: 1px solid var(--gray200);
  border-radius: 8px;
  margin: 24px 0;
  padding: 16px;

  button {
    font-size: 12px;
    font-weight: 600;
    margin-top: 16px;
    padding: 0;
  }
`

export const DescriptionHelpWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-top: 80px;
  padding: 0 24px;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`

export const FooterButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const HelpIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 8px 16px 32px 16px;
  padding: 0;
`

export const ListItem = styled.li``

export const RedemptionTicketsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: 65vh;

  > div:first-of-type > span {
    display: flex;
    margin: 0;
  }
`

export const BannerImage = styled.img`
  width: 100%;
  border-radius: 8px;
`
